"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerCellClasses = exports.HeaderCell = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const Icons_1 = require("../icon/Icons");
const HeaderCell_styles_1 = require("./HeaderCell.styles");
const getJustify = (align) => {
    if (align === 'right')
        return 'flex-end';
    if (align === 'center')
        return 'center';
    return 'flex-start';
};
const headerCellClasses = {
    sorted: 'sorted',
    unsorted: 'unsorted',
    headerBox: 'header-box',
    sortButton: 'sort-button',
};
exports.headerCellClasses = headerCellClasses;
const getSortingClassName = (isSortable, sortDirection) => {
    if (!isSortable)
        return '';
    return sortDirection ? 'sorted' : 'unsorted';
};
const HeaderCell = ({ label, sortDirection, align, isSortable = true, onClick }) => {
    var _a;
    const className = getSortingClassName(!!isSortable, sortDirection);
    const justifyContent = getJustify(align);
    return (react_1.default.createElement(HeaderCell_styles_1.StyledCell, { padding: "none" },
        react_1.default.createElement(material_1.Box, { display: "flex", justifyContent: justifyContent, className: className },
            react_1.default.createElement(material_1.Box, { className: `header-box ${(_a = align === null || align === void 0 ? void 0 : align.toString()) !== null && _a !== void 0 ? _a : ''}`, onClick: onClick },
                label,
                isSortable && (react_1.default.createElement(material_1.IconButton, { className: "sort-button" }, sortDirection === 'asc' ? react_1.default.createElement(Icons_1.ArrowUpward, { fontSize: "small" }) : react_1.default.createElement(Icons_1.ArrowDownward, { fontSize: "small" })))))));
};
exports.HeaderCell = HeaderCell;
//# sourceMappingURL=HeaderCell.js.map